export default __webpack_public_path__ + "static/resting-hands-db377e78657b5fff82eacc04ff05d095.jpg";